import { GroupValueTextTokenElement } from "components/input/token/groupValueTextToken";
import { OptionIterator } from "components/input/select/OptionIterator";
import { isOption, Option } from "components/input/select/options";
import { OverlayElement } from "components/input/overlay/overlay";
import { SelectMultipleCompactHTMLElement } from "./selectMultipleCompactHTMLElement";
import template from "./selectMultipleCompactElement.hbs";

export class SelectMultipleCompactElement extends HTMLElement {

    private _shadowRoot: ShadowRoot;
    private _options: Option[] = [];
    private _codeInOptionLabel: boolean = false;

    private tokens: GroupValueTextTokenElement;
    private overlay: OverlayElement;
    private chevron: HTMLElement;
    private selectMultipleCompactHTMLElement: SelectMultipleCompactHTMLElement;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        //Anadimos template HBS
        const templateHBS = document.createElement("template");
        templateHBS.innerHTML = template();
        this._shadowRoot.appendChild(templateHBS.content.cloneNode(true));

        this.tokens = this._shadowRoot.querySelector("s6-group-value-text-token");
        this.chevron = this._shadowRoot.querySelector(".chevron");

        this.bindEvents();
    }

    private bindEvents(): void {

        this.addEventListener("blur", () => {
            this.tokens.blur();
        });

        this.addEventListener("focus", () => {
            this.focus();
        });

        this.addEventListener("keyup", (e) => {
            if (e.key === " " && !this.hasAttribute("readonly")) {
                this.chevron.dispatchEvent(new Event("click"));
            } else if (e.key === "Escape") {
                this.removeOverlay();
            }
        });

        this.tokens.addEventListener("click", () => {
            this.focus();
            if (this.overlay == null) {
                this.createOverlay();
            } else {
                this.removeOverlay();
            }
        });

        this.tokens.addEventListener("change", () => {
            this.data = this.tokens.data;
            this.dispatchEvent(new Event("change"));
        });

    }

    private createOverlay() {
        this.overlay = document.createElement("s6-overlay") as OverlayElement;

        this.selectMultipleCompactHTMLElement = document.createElement("s6-select-multiple-compact-html") as SelectMultipleCompactHTMLElement;
        this.selectMultipleCompactHTMLElement.setOptions(this._options, this._codeInOptionLabel);
        this.selectMultipleCompactHTMLElement.data = this.dataOption;
        let readonly = (this.getAttribute("readonly") === "true");
        this.selectMultipleCompactHTMLElement.readOnly = readonly;

        this.overlay.appendChild(this.selectMultipleCompactHTMLElement);
        this._shadowRoot.append(this.overlay);

        this.selectMultipleCompactHTMLElement.addEventListener("change", () => {
            //this.data = this.selectMultipleCompactHTMLElement.data.filter((d) => (d.value != null && d.value !== ""));
            this.data = this.selectMultipleCompactHTMLElement.data;
            this.dispatchEvent(new Event("change"));
        });

        if (!readonly) {
            this.selectMultipleCompactHTMLElement.addEventListener("dblclick", () => {
                let lenSelectedValues = this.selectMultipleCompactHTMLElement.getLenghtOptionSelected();
                if (lenSelectedValues == 0) {
                    this.tokens.data = [];
                    this.dispatchEvent(new Event("change"));
                }
            });
        }
    }

    private removeOverlay() {
        this.focus();
        if (this.overlay != null) {
            this.selectMultipleCompactHTMLElement.remove();
            this.selectMultipleCompactHTMLElement = null;
            this.overlay.remove();
            this.overlay = null;
        }
    }

    public set data(data: any[]) {
        let selectedData = [];
        let flatOptions = OptionIterator.filterFlat(this._options ?? [], isOption);
        for (const d of data ?? []) {
            let option;
            if (d.value === undefined) {
                option = flatOptions.find((o) => o.value === d);
            } else {
                option = d;
            }

            selectedData.push({
                value: option.value,
                text: option.text,
                translate: option?.translate,
                tooltip: option?.tooltip,
                codeInOptionLabel: this._codeInOptionLabel,
            });
        }
        this.tokens.data = selectedData;
    }

    public get dataOption(): Option[] {
        if ((this.tokens.data?.length ?? 0) === 0) {
            return null;
        }
        return this.tokens.data;
    }

    public get data() {
        let data = this.dataOption;
        if (data === null) {
            return null;
        }
        return data.map((t) => t.value?.toString() ?? null);
    }

    public focus() {
        super.focus();
        this.tokens.focus();
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.setAttribute("readonly", "true");
            this.chevron.remove();
        } else {
            this.removeAttribute("readonly");
            if (!this.chevron.isConnected) {
                this.tokens.append(this.chevron);
            }
        }
        this.tokens.readOnly = ro;
    }

    public set valid(valid: boolean) {
        this.tokens.valid = valid;
    }

    public set validationMessage(message) {
        this.tokens.validationMessage = message;
    }

    // En este objeto, por ahora, el set y add realizan la misma operacion
    public addOptions(options: Option[], codeInOptionLabel?: boolean): void {
        if (options == null) {
            return;
        }
        if (this._options == null) {
            this._options = [];
        }
        this._codeInOptionLabel = codeInOptionLabel;
        this._options = this._options.concat(options);
    }

    public setOptions(options: Option[], codeInOptionLabel?: boolean): void {
        this._codeInOptionLabel = codeInOptionLabel;
        this._options = options;
    }

    public enableOptions(options: Array<string | number>) {
        this.selectMultipleCompactHTMLElement.enableOptions(options);
    }

    public disableOptions(options: Array<string | number>) {
        this.selectMultipleCompactHTMLElement.disableOptions(options);
    }
}

export function initSelectMultipleCompactWebComponent() {
    window.customElements.define("s6-select-multiple-compact-input", SelectMultipleCompactElement);
}
